<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
  <div class="message" v-html="markdownText" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ text: string }>()

const { marked } = await import('marked')

const markdownText = computed(() => marked(props.text))
</script>

<style lang="css" scoped>
.message {
  @apply body-1 flex flex-col gap-4 mx-auto w-full whitespace-normal;
}

.message :deep(b) {
  @apply text-body-1-bold;
}

.message :deep(a) {
  @apply body-1-link;
}

.message :deep(ul),
.message :deep(ol) {
  @apply indent-12;
}

.message :deep(li) {
  @apply list-disc list-inside;
}

.message :deep(h2) {
  @apply heading-1 mt-20 mb-12;
}

.message :deep(h3) {
  @apply heading-2 mt-20 mb-12;
}

.message :deep(pre) {
  @apply overflow-auto;
}

.message :deep(table) {
  @apply px-24 mb-36 block overflow-x-auto self-center;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100vw;
  border-radius: 0;
}

@media (min-width: theme('screens.md')) {
  .message :deep(table) {
    @apply mb-56 p-32;
    max-width: 1120px;
    width: auto;
  }
}

.message :deep(table p) {
  margin-bottom: 0;
}

.message :deep(table tbody) {
  border-color: inherit;
  width: 100%;
}

.message :deep(tbody tr:last-child) {
  border-bottom: 0;
}

.message :deep(table tr) {
  @apply border-b-1 border-b-static-default-low;
  min-width: 160px;
  max-width: 100%;
}

.message :deep(table th),
.message :deep(table td) {
  @apply p-8 text-left;
  min-width: 160px;
  max-width: 100%;
}

.message :deep(table th) {
  @apply align-bottom;
}

.message :deep(table td) {
  @apply align-top;
}

.message :deep(table tr:first-child th) {
  padding-top: 0;
}

.message :deep(table tr:last-child td) {
  padding-bottom: 0;
}

@media (min-width: theme('screens.md')) {
  .message :deep(table th),
  .message :deep(table td) {
    @apply p-16;
  }
}
</style>
